module.exports = new __parcel__URL__("car.56b20a5e.png").toString();